<template>
  <fragment>
    <div v-if="!isLoading && identicalHashIsValid">
      <hero-header :page-name="$store.state.GeneralManagement.calcData.deviceName" hero-title="shippingInformations"/>
      <shipping-informations-form></shipping-informations-form>
    </div>
    <v-container v-if="isLoading" class="fill-height">
      <v-row class="fill-height" justify="center" align="center" align-content="center">
        <v-col cols="12">
          <div class="text-center">
            <v-progress-circular indeterminate color="primary" :size="50"></v-progress-circular>
          </div>
        </v-col>
        <v-col cols="12">
          <div class="display-1 text-center">
            Egyedi azonosító keresése folyamatban...
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="responseDialog.visible" width="90%" max-width="440" :persistent="true">
      <response-dialog v-bind:response-object="responseDialog.response"
                       v-on:close-dialog="closeResponseDialog"/>
    </v-dialog>
  </fragment>
</template>

<script>
import heroHeader from '../components/heroHeader.vue';
import ShippingInformationsForm from '../components/ShippingInformationsForm.vue';
import responseDialog from "../components/responseDialog.vue";

export default {
  name: 'ShippingPage',
  components: {
    heroHeader, ShippingInformationsForm, responseDialog,
  },
  async mounted() {
    if (this.$route.params.identicalHash) {
      this.identicalHashIsValid = await this.preOfferAcception(this.$route.params.identicalHash);
      if (this.identicalHashIsValid) {
        const succ = await this.getCalcData();
        if (succ) {
          setTimeout(this.loadingFinished, 2200);
        } else {
          this.responseDialog.visible = true;
        }
      } else {
        setTimeout(this.loadingFinished, 2200);
        this.responseDialog.visible = true;
      }
    } else {
      this.$router.push({name: 'home'});
    }
  },
  props: {
    //
  },
  data() {
    return {
      identicalHashIsValid: false,
      isLoading: true,
      responseDialog: {
        visible: false,
        response: {
          error: false,
          message: null,
        },
      },
    };
  },
  methods: {
    async preOfferAcception(hash) {
      const response = await this.$store.dispatch('preOfferAcception', hash);
      // const response = 200;
      if (response === 200) {
        return true;
      } else if(response === 404) {
        this.responseDialog.response.message = '<div class="display-1 mb-6"><b>Érvénytelen egyedi azonosító</b></div><div class="headline mb-4">Ezzel az azonosítóval, már elfogadásra került egy ajánlat!</div>';
      } else {
        this.responseDialog.response.message = '<div class="display-1 mb-6"><b>Szerver hiba</b></div><div class="headline mb-4">A folyamat során váratlan hiba lépett fel!<br>Dolgozunk a hiba elhárításán!</div><div>Köszönjük türelmét!</div>';
      }
      return false;
    },
    async getCalcData() {
      const response = await this.$store.dispatch('getCalcData');
      // const response = 200;
      if (response === 200) {
        return true;
      } else if(response === 404) {
        this.responseDialog.response.message = '<div class="display-1 mb-6"><b>Érvénytelen kalkuláció azonosító</b></div><div class="headline mb-4">Ezzel az azonosítóval nem találtunk ajánlatot a rendszerben!</div>';
      } else {
        this.responseDialog.response.message = '<div class="display-1 mb-6"><b>Szerver hiba</b></div><div class="headline mb-4">A folyamat során váratlan hiba lépett fel!<br>Dolgozunk a hiba elhárításán!</div><div>Köszönjük türelmét!</div>';
      }
      return false;
    },
    closeResponseDialog() {
      this.responseDialog.visible = false;
      this.$router.push({name: 'home'});
    },
    loadingFinished() {
      this.isLoading = false;
    }
  },
};
</script>

<style scoped>

</style>
